import React, { FC } from 'react'

import Price from '../../Price'

const StrikethroughPrice: FC<{ price: number }> = ({ price }) => (
  // TODO: this error popped up when moving the checkout-instore project
  // to checkout-instore-legacy, but needs to be fixed at some point
  // @ts-ignore
  <Price
    className="fw4-s fw4-ns f4-s f3-ns c-muted-2 mr4"
    value={price}
    lineThrough="both"
  />
)

export default StrikethroughPrice
